import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from "@mui/material";
import { CheckCircleOutline } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

interface SuccessDialogProps {
  open: boolean;
  onClose: () => void;
  onViewClick: () => void;
  header: string;
  message: string;
  showFinancesOption?: boolean;
  onGoToFinances?: () => void;
}

export default function SuccessDialog({
  open,
  onClose,
  onViewClick,
  header,
  message,
  showFinancesOption,
  onGoToFinances,
}: SuccessDialogProps) {
  const navigate = useNavigate();

  return (
    <Dialog open={open} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Box display="flex" alignItems="center" gap={1}>
          <CheckCircleOutline color="success" fontSize="large" />
          {header}
          {/*  Transaction Created Successfully */}
        </Box>
      </DialogTitle>
      <DialogContent>
        <Typography
          variant="body1"
          gutterBottom
          fontWeight="bold"
          color="text.primary"
        >
          {message}
          {/* Your transaction was successfully created! */}
        </Typography>
        {/* {transactionId && (
          <Typography variant="body2">
            Transaction ID: {transactionId}
          </Typography>
        )} */}
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            onViewClick(); // Replace with actual transaction ID
            //navigate(`/transactions/view/${transactionId}`);
            onClose();
          }}
          color="primary"
          variant="contained"
        >
          View Transaction
        </Button>
        {showFinancesOption && (
          <Button
            onClick={() => {
              if (onGoToFinances) onGoToFinances();
              onClose();
            }}
            color="primary"
            variant="outlined"
          >
            Go to Financials
          </Button>
        )}
        <Button
          onClick={() => {
            navigate("/dashboard");
            onClose();
          }}
          color="primary"
        >
          Go to Dashboard
        </Button>
      </DialogActions>
    </Dialog>
  );
}
